import { render, staticRenderFns } from "./NoteFeaturedImage.vue?vue&type=template&id=8af6fd06&"
import script from "./NoteFeaturedImage.vue?vue&type=script&lang=js&"
export * from "./NoteFeaturedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports